import { render } from "./TabPane.vue?vue&type=template&id=f89e70e6"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"
script.render = render

export default script